import { render } from "./assign-order.vue?vue&type=template&id=d0af0f28&scoped=true"
import script from "./assign-order.vue?vue&type=script&lang=js"
export * from "./assign-order.vue?vue&type=script&lang=js"

import "./assign-order.vue?vue&type=style&index=0&id=d0af0f28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0af0f28"]])

export default __exports__